<template>
  <div class="container">
    <main-title />
    <div class="card">
      <page-title text="我的作品"></page-title>

      <!-- 有作品：直接展示详情 -->
      <template v-if="dataList.length > 0">
        <!-- 多作品切换 -->
        <div class="work-tabs" v-if="dataList.length > 1">
          <span
            v-for="d in dataList"
            :key="d.id"
            :class="['tab', { active: currentWork && currentWork.id === d.id }]"
            @click="selectWork(d)"
          >{{ d.work_title }}</span>
        </div>

        <div class="viewer" v-if="currentWork" v-loading="detailLoading">
          <div class="medias">
            <template v-if="currentWork.attach_url">
              <div class="title word">作品名称： {{ currentWork.work_title }}</div>
              <a :href="fullAttach" download>{{ currentWork.attach_url }}</a>
              <a :href="fullAttach" class="downIcon">下载</a>
              <div class="douyin-qr">
                <img src="@/assets/sqhsn-douyin.png" alt="抖音二维码" />
                <!-- <p>抖音扫码免费观看<br />快速提升作文技巧</p> -->
              </div>
            </template>
          </div>
          <div class="infos">
            <dl>
              <dt>所在地区</dt>
              <dd>{{ currentWork.region_name }}</dd>
              <dt>所在学校</dt>
              <dd>{{ currentWork.school_name }}</dd>
              <template v-for="(a, index) in currentWork.authors">
                <div :key="index">
                  <dt>学生姓名</dt>
                  <dd>{{ typeof a === 'string' ? a : a.name }}</dd>
                </div>
              </template>
              <dt>组别</dt>
              <dd>{{ currentWork.group_name }}</dd>
              <dt>年级</dt>
              <dd>{{ showGrade(currentWork.grade) }}</dd>
              <dt>指导老师</dt>
              <dd>{{ currentWork.teacher }}</dd>
            </dl>
            <el-button type="primary" @click="toEdit(currentWork.id)">编辑</el-button>
          </div>
        </div>
      </template>

      <!-- 无作品：引导添加 -->
      <template v-else-if="!dataLoading">
        <div class="empty-state">
          <p>暂无作品，立即添加</p>
          <!-- <button class="primary lg" @click="toAdd">添加作品</button> -->
          <el-button type="danger" @click="toAdd">添加作品</el-button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { getMyWorks, authFile } from "@/api/work.js";
import eventBus from '@/utils/eventBus'

export default {
  name: "myWorksPage",
  data() {
    return {
      searchData: {
        competition_id: 202601,
        page: 1,
        limit: 100,
      },
      dataList: [],
      dataLoading: false,
      detailLoading: false,
      currentWork: null,
      fullAttach: "",
      gradeList: [
        { id: 1, name: "一年级" },
        { id: 2, name: "二年级" },
        { id: 3, name: "三年级" },
        { id: 4, name: "四年级" },
        { id: 5, name: "五年级" },
        { id: 6, name: "六年级" },
        { id: 7, name: "七年级" },
        { id: 8, name: "八年级" },
        { id: 9, name: "九年级" },
        { id: 10, name: "高一" },
        { id: 11, name: "高二" },
        { id: 12, name: "高三" }
      ],
    };
  },
  created() {
    this.toGetList();
    eventBus.$on('changeCompetition', id => {
      this.searchData.competition_id = id
      this.toGetList();
    })
  },
  methods: {
    /**
     * 获取个人作品列表
     */
    toGetList() {
      this.dataLoading = true;
      getMyWorks(this.searchData)
        .then((d) => {
          this.dataList = d.data;
          this.dataLoading = false;
          // 默认选中第一个作品展示详情
          if (this.dataList.length > 0) {
            this.selectWork(this.dataList[0]);
          }
        })
        .catch((e) => {
          this.dataLoading = false;
        });
    },
    /**
     * 选中作品并加载附件签名
     */
    async selectWork(work) {
      this.currentWork = work;
      this.detailLoading = true;
      this.fullAttach = "";
      if (work.attach_url) {
        try {
          const r = await authFile({ key: work.attach_url });
          this.fullAttach = r.data;
        } catch (e) {
          // ignore
        }
      }
      this.detailLoading = false;
    },
    /**
     * 跳转到添加页
     */
    toAdd() {
      this.$router.push("/my-add");
    },
    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      this.$router.push({ path: "/my-add", query: { id } });
    },
    showGrade(g) {
      var typeValue = this.gradeList.filter((d) => d.id == g);
      return typeValue ? (typeValue.length > 0 ? typeValue[0].name : "") : "";
    },
  },
};
</script>
<style lang="scss" scoped>
.douyin-qr {
  position: relative;
  // left: 120px;
  top: 140px;
  transform: translateY(-50%);
  width: 185px;
  height: auto;
  text-align: center;
  z-index: 1000;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  p {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
    line-height: 1.5;
  }
}
.work-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 16px 60px 0;
  .tab {
    padding: 6px 16px;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    background: #f5f5f5;
    cursor: pointer;
    &.active {
      color: #fff;
      background: #bc463b;
    }
    &:hover:not(.active) {
      color: #bc463b;
    }
  }
}
.viewer {
  display: flex;
  padding: 10px 60px 70px;
  background-color: #fff;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
  .medias {
    width: 55%;
    .title {
      margin: 30px 0 15px 0;
      padding-left: 24px;
      font-size: 18px;
      background: no-repeat left center;
      font-weight: 700;
      &.word {
        background-image: url("../../assets/icon_word.png");
      }
    }
    a {
      color: #999999;
      font-size: 16px;
      &:hover {
        color: #bf3d36;
      }
      &:active {
        color: #999999;
      }
    }
    .downIcon {
      margin-left: 20px;
      padding-left: 20px;
      color: #bf3d36;
      background: url("../../assets/icon_download.png") no-repeat left center;
    }
  }
  .infos {
    // padding-top: 40px;
    padding-left: 90px;
    width: 45%;
    dt {
      line-height: 46px;
      float: left;
      width: 120px;
    }
    dd {
      padding-top: 11px;
      min-height: 46px;
      line-height: 24px;
      overflow: hidden;
      font-weight: 700;
    }
    .add-btn {
      margin-left: 12px;
    }
  }
}
.empty-state {
  padding: 80px 0;
  text-align: center;
  p {
    font-size: 20px;
    color: #999;
    margin-bottom: 24px;
  }
}

/* 隐藏页面原有的返回箭头 */
::v-deep .page_title .back {
  display: none;
}
</style>
